import { type FC } from "react";

export const FragmentEnvironmentCreation: FC<{
    environmentId: string;
}> = () => {
    // For now we don't render anything for the environment creation fragment
    // as it's coverated by the actionStart/actionCompleted together with the
    // environment status showing in the conversation header.
    return null;
};
